import { render, staticRenderFns } from "./InstalikeContent.vue?vue&type=template&id=4df82bd4&"
import script from "./InstalikeContent.vue?vue&type=script&lang=ts&"
export * from "./InstalikeContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports